import { render, staticRenderFns } from "./BotDescription.vue?vue&type=template&id=1f36b842&"
import script from "./BotDescription.vue?vue&type=script&lang=js&"
export * from "./BotDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports